<template>
  <v-form>
    <validation-observer ref="observer" v-slot="{invalid, reset, handleSubmit}">
      <v-card>
        <v-card-title>{{model.id ? 'Изменить склад' : 'Создать склад'}}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col>
              <validation-provider v-slot="{errors}" name="warehouse_name" rules="required|max:256">
                <v-text-field v-model="model.name"
                              required :error-messages="errors"
                              label="Название"
                ></v-text-field>
              </validation-provider>
            </v-col>
            <v-col>
              <validation-provider v-slot="{errors}" name="warehouse_type" rules="required|max:256">
                <v-select v-model="model.type"
                          item-text="title" item-value="id"
                          :items="types"
                          required :error-messages="errors"
                          label="Тип"
                ></v-select>
              </validation-provider>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-space-between pb-4 px-4">
          <v-btn @click="handleSubmit(save)"
                 :loading="!!saving"
                 :disabled="!!saving || invalid"
                 rounded color="success"
          ><v-icon left>mdi-content-save</v-icon> {{model.id ? 'Сохранить' : 'Создать'}}</v-btn>
          <v-btn @click="cancel(reset)"
                 :disabled="!!saving"
                 :loading="!!saving"
                 rounded text color="error"
          ><v-icon left>mdi-cancel</v-icon> Отмена</v-btn>
        </v-card-actions>
      </v-card>
    </validation-observer>
  </v-form>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    name: 'warehouse-form',

    computed: {
      ...mapState('Warehouse', ['saving', 'model', 'types']),
    },

    methods: {
      cancel(reset) {
        reset()
        this.$emit('warehouse:form:cancel')
      },

      save() {
        this.$store
          .dispatch('Warehouse/save')
          .then(() => {
            this.$emit('warehouse:form:saved')
          })
      },
    },
  }
</script>
